import type { ReviseContractResponse } from '@weft/api-definition';
import { ReviseContractResponseSchema } from '@weft/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import type { ReviseContractRequest } from './use-revise-contract-types/revise-contract-request';

export function useReviseContract(options?: UseMutationOptions<ReviseContractResponse, unknown, ReviseContractRequest>) {
  return useMutation({
    mutationFn: async (requestParameters) => {
      const api = getPrivateApi();
      const reviseContractResponse = await api.reviseContract(requestParameters);

      return ReviseContractResponseSchema.parse(reviseContractResponse);
    },
    ...options,
  });
}